import React from 'react';
import './Hero.css';

function Hero({ cartCount, onCartClick }) {
  return (
    <div className="hero">
      <div className="hero-content">
        <div className="cart-icon" onClick={onCartClick}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
        </div>

        <h1 className="hero-title">Off the Stage, Still First Chair.</h1>
        <p className="hero-subtitle">A symbol of the hours they'll never see.</p>
        <p className="hero-cta">Choose it. Wear it with pride.</p>
      </div>
    </div>
  );
}

export default Hero;
